"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 1H5v22h14zm-5 20h-4v-1h4zm3-3H7V4h10z"
}), 'PhoneAndroidSharp');